import { render, staticRenderFns } from "./SiteMenuContainer.vue?vue&type=template&id=bc142226&"
import script from "./SiteMenuContainer.vue?vue&type=script&lang=js&"
export * from "./SiteMenuContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports